import { createContext, useContext } from "react";

interface WebSocketContextType {
  lastMessage: MessageEvent | null;
  readyState: number;
  sendMessage: (message: string) => void;
}

export const WebSocketContext = createContext<WebSocketContextType | null>(
  null,
);

export const useGlobalWebSocket = () => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error("useGlobalWebSocket必须在WebSocketProvider中使用");
  }
  return context;
};
